import { shape, string } from 'prop-types';

export const timeZoneType = shape({
  name: string,
  displayOffset: string,
  momentOffset: string,
  abbv: string,
  timezoneKey: string
});
export const DEFAULT_TIME_ZONE_NAME = 'pacific time';
export const DEFAULT_TIME_ZONE_KEY = 'America/Los_Angeles';
export const NOT_FOUND = 'NOT FOUND';

export const popularTimeZoneNames = [
  'atlantic time',
  'central time',
  'eastern time',
  'greenwich mean time',
  'mountain time',
  'pacific time',
  'saskatchewan time',
  'hawaii standard time',
  'hawaii-aleutian daylight time',
  'alaska time'
];

//subresouce integrity for JSON file.
export const TIMEZONE_SRC = 'https://s3.amazonaws.com/static.veritone.com/email/attribute_app/timezones_v2.json';
export const TIMEZONE_INTEGRITY_KEY = 'sha384-Cb9HwC9hONodt7FqBd4TZuE4ffgprdek0GVxqpwhb58ppbhajEu3dtlC+eUO5hR+';

export const PLAYOUT_STATION_TIMEZONE = {
  name: 'Station Timezone',
  displayOffset: '',
  momentOffset: '',
  abbv: '',
  timezoneKey: '0'
};
